import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Badge, Form, Modal, Alert } from 'react-bootstrap';
// import { toast } from 'react-toastify';
import { RestaurantMenuContext, RestaurantMenuProvider } from '../Components/RestaurantMenuContext';
import './PublicRestaurantMenu.css';
import { withNamespaces } from "react-i18next"
import { connect } from "react-redux"

const PublicRestaurantMenuContent = () => {
    console.log('PublicRestaurantMenu component loaded');
    const { menuSlug } = useParams();
    console.log('Menu slug:', menuSlug);
    
    // Get store data from context
    const { storeData } = useContext(RestaurantMenuContext);
    const [loading, setLoading] = useState(true);
    const [menuData, setMenuData] = useState(null);
    const [cart, setCart] = useState({});
    const [showCart, setShowCart] = useState(false);
    const [showOrderHistory, setShowOrderHistory] = useState(false);
    const [orderSuccess, setOrderSuccess] = useState(false);
    const [filter, setFilter] = useState('');
    const [orderData, setOrderData] = useState({});
    const [paymentLinks, setPaymentLinks] = useState([]);
    const [orderHistoryData, setOrderHistoryData] = useState([]);
    const [processing, setProcessing] = useState(false);
    
    // Customer form data
    const [customerData, setCustomerData] = useState({
        name: '',
        phone: '',
        email: '',
        address: '',
        restaurant_order_type: 'DINE_IN'
    });

    // Cart calculations
    const [cartTotals, setCartTotals] = useState({
        subTotal: 0,
        discountTotal: 0,
        totalAfterDiscount: 0,
        taxTotal: 0,
        total: 0,
        itemCount: 0
    });

    useEffect(() => {
        fetchMenuData();
    }, [menuSlug]);

    useEffect(() => {
        updateCartTotals();
    }, [cart]);

    // Debug store data from context
    useEffect(() => {
        console.log('🏪 Store data from context:', storeData);
        const localStorageStoreData = localStorage.getItem('digitalmenu_store_data');
        if (localStorageStoreData) {
            console.log('💾 Store data from localStorage:', JSON.parse(localStorageStoreData));
        }
    }, [storeData]);

    const fetchMenuData = async () => {
        try {
            setLoading(true);
            
            // For now, use mock data since backend API is not implemented
            // In production, this would fetch from: `/api/restaurant_menu/${menuSlug}`
            
            // Mock data for testing
            const mockData = {
                success: true,
                data: {
                    store: {
                        slack: 'store_123',
                        name: 'MT Test Store 26',
                        logo: '/images/default-logo.png',
                        currency_code: 'INR'
                    },
                    table: {
                        slack: 'table_123',
                        table_number: 'T1'
                    },
                    categories: [
                        { label: 'Biryani', slack: 'cat_1' },
                        { label: 'Deserts', slack: 'cat_2' },
                        { label: 'Drinks', slack: 'cat_3' }
                    ],
                    category_products: {
                        biryani: {
                            label: 'Biryani',
                            slack: 'cat_1',
                            products: [
                                {
                                    slack: 'prod_1',
                                    name: 'Biryani',
                                    sale_amount_excluding_tax: '150.00',
                                    discount_code: { discount_percentage: 50 },
                                    tax_percentage: 0,
                                    images: [{ thumbnail: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgZmlsbD0iI2Y4ZjlmYSIvPjx0ZXh0IHg9IjUwIiB5PSI1NSIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjE0IiBmaWxsPSIjNmM3NTdkIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj5NZW51PC90ZXh0Pjwvc3ZnPg==' }]
                                },
                                {
                                    slack: 'prod_2',
                                    name: 'Chicken Biryani',
                                    sale_amount_excluding_tax: '372.80',
                                    discount_code: null,
                                    tax_percentage: 0,
                                    images: [{ thumbnail: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgZmlsbD0iI2Y4ZjlmYSIvPjx0ZXh0IHg9IjUwIiB5PSI1NSIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjE0IiBmaWxsPSIjNmM3NTdkIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj5NZW51PC90ZXh0Pjwvc3ZnPg==' }]
                                }
                            ]
                        },
                        deserts: {
                            label: 'Deserts',
                            slack: 'cat_2',
                            products: [
                                {
                                    slack: 'prod_3',
                                    name: 'Momo',
                                    sale_amount_excluding_tax: '80.00',
                                    discount_code: { discount_percentage: 5 },
                                    tax_percentage: 0,
                                    images: [{ thumbnail: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgZmlsbD0iI2Y4ZjlmYSIvPjx0ZXh0IHg9IjUwIiB5PSI1NSIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjE0IiBmaWxsPSIjNmM3NTdkIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj5NZW51PC90ZXh0Pjwvc3ZnPg==' }]
                                }
                            ]
                        },
                        drinks: {
                            label: 'Drinks',
                            slack: 'cat_3',
                            products: [
                                {
                                    slack: 'prod_4',
                                    name: 'COCA-COLA',
                                    sale_amount_excluding_tax: '49.82',
                                    discount_code: null,
                                    tax_percentage: 0,
                                    images: [{ thumbnail: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgZmlsbD0iI2Y4ZjlmYSIvPjx0ZXh0IHg9IjUwIiB5PSI1NSIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjE0IiBmaWxsPSIjNmM3NTdkIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj5NZW51PC90ZXh0Pjwvc3ZnPg==' }]
                                }
                            ]
                        }
                    }
                }
            };

            // Simulate API delay
            await new Promise(resolve => setTimeout(resolve, 1000));
            
            setMenuData(mockData.data);
            
        } catch (error) {
            console.error('Error fetching menu:', error);
            // toast.error('Failed to load menu');
        } finally {
            setLoading(false);
        }
    };

    const updateCartTotals = () => {
        let subTotal = 0;
        let discountTotal = 0;
        let taxTotal = 0;
        let itemCount = 0;

        Object.values(cart).forEach(item => {
            const itemTotal = parseFloat(item.unit_price) * parseInt(item.quantity);
            subTotal += itemTotal;
            itemCount += parseInt(item.quantity);
            
            // Calculate discount if any
            if (item.discount_percentage > 0) {
                discountTotal += (itemTotal * item.discount_percentage) / 100;
            }
            
            // Calculate tax if any
            if (item.tax_percentage > 0) {
                const taxableAmount = itemTotal - ((itemTotal * item.discount_percentage) / 100);
                taxTotal += (taxableAmount * item.tax_percentage) / 100;
            }
        });

        const totalAfterDiscount = subTotal - discountTotal;
        const total = totalAfterDiscount + taxTotal;

        setCartTotals({
            subTotal: subTotal.toFixed(2),
            discountTotal: discountTotal.toFixed(2),
            totalAfterDiscount: totalAfterDiscount.toFixed(2),
            taxTotal: taxTotal.toFixed(2),
            total: total.toFixed(2),
            itemCount
        });
    };

    const addToCart = (product) => {
        const cartKey = product.slack;
        
        if (cart[cartKey]) {
            setCart(prev => ({
                ...prev,
                [cartKey]: {
                    ...prev[cartKey],
                    quantity: prev[cartKey].quantity + 1
                }
            }));
        } else {
            setCart(prev => ({
                ...prev,
                [cartKey]: {
                    slack: product.slack,
                    name: product.name,
                    unit_price: product.sale_amount_excluding_tax,
                    quantity: 1,
                    discount_percentage: product.discount_code?.discount_percentage || 0,
                    tax_percentage: product.tax_percentage || 0,
                    image: product.images?.[0]?.thumbnail || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgZmlsbD0iI2Y4ZjlmYSIvPjx0ZXh0IHg9IjUwIiB5PSI1NSIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjE0IiBmaWxsPSIjNmM3NTdkIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj5NZW51PC90ZXh0Pjwvc3ZnPg=='
                }
            }));
        }
        
        console.log(`${product.name} added to cart`);
    };

    const updateQuantity = (cartKey, change) => {
        setCart(prev => {
            const newCart = { ...prev };
            const newQuantity = newCart[cartKey].quantity + change;
            
            if (newQuantity <= 0) {
                delete newCart[cartKey];
            } else {
                newCart[cartKey].quantity = newQuantity;
            }
            
            return newCart;
        });
    };

    const removeFromCart = (cartKey) => {
        setCart(prev => {
            const newCart = { ...prev };
            delete newCart[cartKey];
            return newCart;
        });
    };

    const filteredProducts = (products) => {
        if (!filter) return products;
        
        return products.filter(product =>
            product.name.toLowerCase().includes(filter.toLowerCase())
        );
    };

    const submitOrder = async () => {
        if (Object.keys(cart).length === 0) {
            alert('Your cart is empty');
            return;
        }

        if (!customerData.name || !customerData.phone) {
            alert('Please provide your name and contact number');
            return;
        }

        try {
            setProcessing(true);
            
            const orderPayload = {
                store_slack: menuData.store.slack,
                customer: {
                    name: customerData.name,
                    phone: customerData.phone,
                    email: customerData.email
                },
                restaurant_mode: 1,
                restaurant_order_type: customerData.restaurant_order_type,
                cart: cart,
                address: customerData.address,
                table_slack: menuData.table?.slack || ''
            };

            const response = await fetch('/api/add_customer_order', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(orderPayload)
            });

            const data = await response.json();
            
            if (data.status_code === 200) {
                setOrderData(data.data);
                setPaymentLinks(data.data.payment_links || []);
                setOrderSuccess(true);
                setShowCart(false);
                setCart({});
                alert('Order submitted successfully!');
            } else {
                alert(data.msg || 'Failed to submit order');
            }
        } catch (error) {
            console.error('Error submitting order:', error);
            alert('Failed to submit order');
        } finally {
            setProcessing(false);
        }
    };

    const showOrderHistoryModal = () => {
        setShowOrderHistory(true);
        // Load order history from cookies or localStorage
        // This would typically fetch from an API
    };

    const newOrder = () => {
        setOrderSuccess(false);
        setShowCart(false);
        setOrderData({});
        setPaymentLinks([]);
        setCustomerData({
            name: '',
            phone: '',
            email: '',
            address: '',
            restaurant_order_type: 'DINE_IN'
        });
    };

    console.log('Render - loading:', loading, 'menuData:', menuData);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center min-vh-100">
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
                <p className="ms-3">Loading menu data...</p>
            </div>
        );
    }

    if (!menuData) {
        return (
            <Container className="text-center py-5">
                <Alert variant="danger">
                    <h4>Menu Not Found</h4>
                    <p>The requested menu is not available or has been removed.</p>
                </Alert>
            </Container>
        );
    }

    return (
        <div className="public-restaurant-menu">
            <Container fluid className="px-0">
                <Row className="no-gutters">
                    <Col xs={12} md={8} lg={6} className="mx-auto">
                        
                        {/* Header */}
                        <div className="menu-header d-flex justify-content-between align-items-center p-3 border-bottom bg-white sticky-top">
                            <div className="d-flex align-items-center">
                                <img 
                                    src={menuData.store.logo || '/images/default-logo.png'} 
                                    alt="Store Logo" 
                                    className="store-logo me-2"
                                />
                                <span className="store-name">
                                    {storeData?.name || 
                                     JSON.parse(localStorage.getItem('digitalmenu_store_data') || '{}')?.name || 
                                     menuData.store.name || 
                                     'Restaurant Menu'}
                                </span>
                            </div>
                            <div className="d-flex align-items-center">
                                <Button 
                                    variant="link" 
                                    className="p-2 me-2" 
                                    onClick={showOrderHistoryModal}
                                    title="Order History"
                                >
                                    <i className="fas fa-history"></i>
                                </Button>
                                {cartTotals.itemCount > 0 && (
                                    <Button 
                                        variant="link" 
                                        className="cart-trigger-mobile p-2 position-relative" 
                                        onClick={() => setShowCart(true)}
                                        title="View Cart"
                                    >
                                        <i className="fas fa-shopping-bag"></i>
                                        <Badge 
                                            bg="danger" 
                                            className="position-absolute top-0 start-100 translate-middle rounded-pill"
                                        >
                                            {cartTotals.itemCount}
                                        </Badge>
                                    </Button>
                                )}
                            </div>
                        </div>

                        {/* Order Success View */}
                        {orderSuccess && (
                            <div className="text-center py-5 bg-white">
                                <div className="mb-3">
                                    <i className="fas fa-check-circle text-success" style={{fontSize: '4rem'}}></i>
                                </div>
                                <h4>Order Submitted Successfully!</h4>
                                <p className="order-number">Order Number: {orderData.order_number}</p>
                                <Button variant="primary" onClick={newOrder} className="mb-3">
                                    New Order +
                                </Button>
                                
                                {paymentLinks.length > 0 && (
                                    <div>
                                        <p className="text-primary fw-bold">Do you wish to pay now?</p>
                                        {paymentLinks.map((link, index) => (
                                            <div key={index} className="mb-2">
                                                <a href={link.link} className="btn btn-outline-primary">
                                                    Pay using {link.label}
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Menu Items View */}
                        {!showCart && !orderSuccess && (
                            <>
                                {/* Search Bar */}
                                <div className="p-3 bg-light border-bottom">
                                    <Form.Control
                                        type="text"
                                        placeholder="Search items..."
                                        value={filter}
                                        onChange={(e) => setFilter(e.target.value)}
                                        className="search-input"
                                    />
                                </div>

                                {/* Category Pills */}
                                {menuData.categories && (
                                    <div className="category-pills p-3 border-bottom bg-white">
                                        <div className="d-flex flex-nowrap overflow-auto">
                                            {menuData.categories.map((category, index) => (
                                                <Badge 
                                                    key={index}
                                                    pill 
                                                    bg="primary" 
                                                    className="me-2 flex-shrink-0"
                                                    as="a"
                                                    href={`#${category.label}`}
                                                >
                                                    {category.label}
                                                </Badge>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {/* Table Info */}
                                {menuData.table && (
                                    <div className="p-3 bg-light">
                                        <span className="text-muted me-2">Table:</span>
                                        <span className="fw-bold">{menuData.table.table_number}</span>
                                    </div>
                                )}

                                {/* Menu Categories and Products */}
                                <div className="menu-content p-3">
                                    {menuData.category_products && Object.entries(menuData.category_products).map(([categoryKey, category]) => {
                                        const filteredCategoryProducts = filteredProducts(category.products);
                                        
                                        if (filteredCategoryProducts.length === 0) return null;
                                        
                                        return (
                                            <div key={categoryKey} id={category.label} className="mb-4">
                                                <h5 className="category-title mb-3">{category.label}</h5>
                                                
                                                {filteredCategoryProducts.map((product, index) => (
                                                    <Card key={index} className="product-card mb-3 border-0 border-bottom">
                                                        <Card.Body className="p-3">
                                                            <div className="d-flex align-items-start">
                                                                <div className="product-image me-3">
                                                                    <img
                                                                        src={product.images?.[0]?.thumbnail || 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgZmlsbD0iI2Y4ZjlmYSIvPjx0ZXh0IHg9IjUwIiB5PSI1NSIgZm9udC1mYW1pbHk9IkFyaWFsLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjE0IiBmaWxsPSIjNmM3NTdkIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIj5NZW51PC90ZXh0Pjwvc3ZnPg=='}
                                                                        alt={product.name}
                                                                        className="rounded-circle"
                                                                        style={{width: '50px', height: '50px', objectFit: 'cover'}}
                                                                    />
                                                                </div>
                                                                
                                                                <div className="product-info flex-grow-1">
                                                                    {cart[product.slack] && (
                                                                        <Badge bg="success" className="mb-1">
                                                                            <i className="fas fa-check me-1"></i>
                                                                            Added to cart
                                                                        </Badge>
                                                                    )}
                                                                    
                                                                    <h6 className="product-title mb-1">
                                                                        {product.name.length > 35 ? 
                                                                            `${product.name.substring(0, 35)}...` : 
                                                                            product.name
                                                                        }
                                                                    </h6>
                                                                    
                                                                    <div className="product-price">
                                                                        <span className="currency">{menuData.store.currency_code}</span>
                                                                        <span className="amount ms-1">{product.sale_amount_excluding_tax}</span>
                                                                        {product.discount_code?.discount_percentage > 0 && (
                                                                            <Badge bg="success" className="ms-2">
                                                                                <i className="fas fa-tags me-1"></i>
                                                                                {product.discount_code.discount_percentage}%
                                                                            </Badge>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                
                                                                <Button 
                                                                    variant="primary" 
                                                                    size="sm"
                                                                    onClick={() => addToCart(product)}
                                                                    className="add-btn"
                                                                >
                                                                    <i className="fas fa-plus"></i>
                                                                </Button>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                ))}
                                            </div>
                                        );
                                    })}
                                </div>

                                {/* Mobile sticky cart bar */}
                                {cartTotals.itemCount > 0 && (
                                    <div className="cart-fab-bar d-flex d-md-none" onClick={() => setShowCart(true)}>
                                        <div className="cart-info">
                                            <span className="cart-items-count">{cartTotals.itemCount} item{cartTotals.itemCount > 1 ? 's' : ''}</span>
                                            <span className="cart-total-amount">{menuData.store.currency_code} {Number(cartTotals.total).toFixed(2)}</span>
                                        </div>
                                        <Button variant="primary" onClick={() => setShowCart(true)}>
                                            View Cart
                                        </Button>
                                    </div>
                                )}
                            </>
                        )}

                        {/* Cart View */}
                        {showCart && !orderSuccess && (
                            <div className="cart-view bg-white p-3">
                                <div className="d-flex align-items-center mb-3">
                                    <Button 
                                        variant="link" 
                                        className="p-0 me-2"
                                        onClick={() => setShowCart(false)}
                                    >
                                        <i className="fas fa-arrow-left"></i>
                                    </Button>
                                    <h4 className="mb-0">Cart</h4>
                                </div>

                                {Object.keys(cart).length > 0 ? (
                                    <>
                                        {/* Cart Items */}
                                        {Object.entries(cart).map(([cartKey, item]) => (
                                            <Card key={cartKey} className="cart-item mb-3 border-0 border-bottom">
                                                <Card.Body className="p-3">
                                                    <div className="d-flex justify-content-end mb-2">
                                                        <Button 
                                                            variant="light" 
                                                            size="sm" 
                                                            className="rounded-circle"
                                                            onClick={() => removeFromCart(cartKey)}
                                                        >
                                                            ×
                                                        </Button>
                                                    </div>
                                                    
                                                    <div className="d-flex align-items-start">
                                                        <img
                                                            src={item.image}
                                                            alt={item.name}
                                                            className="rounded-circle me-3"
                                                            style={{width: '50px', height: '50px', objectFit: 'cover'}}
                                                        />
                                                        
                                                        <div className="flex-grow-1">
                                                            <h6 className="mb-1">{item.name}</h6>
                                                            <div className="text-muted">
                                                                <span className="currency">{menuData.store.currency_code}</span>
                                                                <span className="ms-1">{(item.unit_price * item.quantity).toFixed(2)}</span>
                                                            </div>
                                                        </div>
                                                        
                                                        <div className="d-flex align-items-center">
                                                            <span className="me-3 fw-bold">{item.quantity}</span>
                                                            <Button 
                                                                variant="outline-primary" 
                                                                size="sm" 
                                                                className="me-2"
                                                                onClick={() => updateQuantity(cartKey, -1)}
                                                            >
                                                                <i className="fas fa-minus"></i>
                                                            </Button>
                                                            <Button 
                                                                variant="outline-primary" 
                                                                size="sm"
                                                                onClick={() => updateQuantity(cartKey, 1)}
                                                            >
                                                                <i className="fas fa-plus"></i>
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        ))}

                                        {/* Cart Summary */}
                                        <div className="cart-summary mb-4">
                                            <div className="d-flex justify-content-between mb-2">
                                                <span>Sub total</span>
                                                <span>{cartTotals.subTotal}</span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span>Discount</span>
                                                <span>{cartTotals.discountTotal}</span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span>Total After Discount</span>
                                                <span>{cartTotals.totalAfterDiscount}</span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span>Total Tax</span>
                                                <span>{cartTotals.taxTotal}</span>
                                            </div>
                                            <div className="d-flex justify-content-between fw-bold fs-5">
                                                <span>Total</span>
                                                <span>
                                                    <span className="currency">{menuData.store.currency_code}</span>
                                                    <span className="ms-1">{cartTotals.total}</span>
                                                </span>
                                            </div>
                                        </div>

                                        {/* Customer Form */}
                                        <Form>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Order Type</Form.Label>
                                                <div className="d-flex flex-wrap">
                                                    {['DINE_IN', 'TAKEAWAY', 'DELIVERY'].map((type) => (
                                                        <Form.Check
                                                            key={type}
                                                            type="radio"
                                                            name="restaurant_order_type"
                                                            id={`order_type_${type}`}
                                                            label={type.replace('_', ' ')}
                                                            value={type}
                                                            checked={customerData.restaurant_order_type === type}
                                                            onChange={(e) => setCustomerData(prev => ({
                                                                ...prev,
                                                                restaurant_order_type: e.target.value
                                                            }))}
                                                            className="me-3"
                                                        />
                                                    ))}
                                                </div>
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label>Name *</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Please provide Name"
                                                    value={customerData.name}
                                                    onChange={(e) => setCustomerData(prev => ({
                                                        ...prev,
                                                        name: e.target.value
                                                    }))}
                                                    required
                                                />
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label>Contact Number *</Form.Label>
                                                <Form.Control
                                                    type="tel"
                                                    placeholder="Please provide Contact Number"
                                                    value={customerData.phone}
                                                    onChange={(e) => setCustomerData(prev => ({
                                                        ...prev,
                                                        phone: e.target.value
                                                    }))}
                                                    required
                                                />
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label>Email</Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    placeholder="Please provide your Email"
                                                    value={customerData.email}
                                                    onChange={(e) => setCustomerData(prev => ({
                                                        ...prev,
                                                        email: e.target.value
                                                    }))}
                                                />
                                            </Form.Group>

                                            {customerData.restaurant_order_type === 'DELIVERY' && (
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Address</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        placeholder="Please provide Delivery Address"
                                                        value={customerData.address}
                                                        onChange={(e) => setCustomerData(prev => ({
                                                            ...prev,
                                                            address: e.target.value
                                                        }))}
                                                    />
                                                </Form.Group>
                                            )}

                                            <Button 
                                                variant="primary" 
                                                size="lg" 
                                                className="w-100"
                                                onClick={submitOrder}
                                                disabled={processing}
                                            >
                                                {processing && <i className="fas fa-spinner fa-spin me-2"></i>}
                                                Submit Order
                                            </Button>
                                        </Form>
                                    </>
                                ) : (
                                    <div className="text-center py-5">
                                        <i className="fas fa-shopping-bag text-muted mb-3" style={{fontSize: '3rem'}}></i>
                                        <p>Your cart is empty</p>
                                    </div>
                                )}
                            </div>
                        )}

                    </Col>
                </Row>
            </Container>

            {/* Order History Modal */}
            <Modal show={showOrderHistory} onHide={() => setShowOrderHistory(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Order History</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {orderHistoryData.length > 0 ? (
                        orderHistoryData.map((order, index) => (
                            <Card key={index} className="mb-3">
                                <Card.Body>
                                    <div className="d-flex justify-content-between mb-2">
                                        <h6>#{order.order_number}</h6>
                                        <span>{order.currency_code} {order.total_order_amount}</span>
                                    </div>
                                    <div className="order-status mb-2">
                                        {order.status && (
                                            <Badge bg={order.status.color} className="me-2">
                                                {order.status.label}
                                            </Badge>
                                        )}
                                    </div>
                                    <div className="order-items">
                                        {order.products && order.products.map((product, idx) => (
                                            <div key={idx} className="d-flex justify-content-between">
                                                <span>{product.name}</span>
                                                <span>Qty: {product.quantity}</span>
                                            </div>
                                        ))}
                                    </div>
                                </Card.Body>
                            </Card>
                        ))
                    ) : (
                        <div className="text-center py-4">
                            <p>Your order history is empty</p>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
};

// Wrapper component with RestaurantMenuProvider
const PublicRestaurantMenu = () => {
    const { menuSlug } = useParams();
    const orgId = parseInt(JSON.parse(localStorage.getItem('digitalmenu_store_data') || '{}')?.org_id) || 0;
    
    return (
        <RestaurantMenuProvider menuSlug={menuSlug} orgId={orgId}>
            <PublicRestaurantMenuContent currentStore={currentStore}/>
        </RestaurantMenuProvider>
    );
};

// export default PublicRestaurantMenu;

const mapStateToProps = (state) => ({
  currentStore: state.StoreReducer.currentStore
});

export default connect(mapStateToProps)(withNamespaces()(PublicRestaurantMenu))

